import React from 'react'
import moment from 'moment';

import PurchaseOrderInvoiceTable from 'components/Invoices/PurchaseOrderInvoiceTable';
import styles from 'components/Invoices/Invoice.module.scss';

class PurchaseOrderInvoice extends React.Component {
  
  formatCurrency = (amount) => {
    return (new Intl.NumberFormat('en-AE', {
      style: 'currency',
      currency: 'AED',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount))
  }

  render = () => {
    return (
      <div className={styles.invoice}>
        <div className={styles.brand}>
          <img style={{ maxWidth: "100px", marginLeft:"42%", borderRadius: "50%"}} src={this.props.user.companyLogo} alt={this.props.user.name} />
        </div>
        <div className={styles.addresses}>
          <div>
            <div className={`${styles.valueTable} ${styles.to}`}>
              <div className={styles.row}>
                <div className={styles.label}>Invoice #</div>
                <div className={styles.value}>{this.props.info.displayId}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Vendor Name</div>
                <div className={styles.value}>{this.props.info.vendorName}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Vendor TRN</div>
                <div className={styles.value}>{this.props.info.vendorTrn}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Date</div>
                <div className={`${styles.value} ${styles.date}`}>{moment(this.props.info.paymentDate).format('DD/MM/YYYY')}</div>
              </div>
            </div>
          </div>
          <div className={styles.from}>
            {/*<strong>Amazing Company</strong><br />
              123 Kensington Ave<br />
              Toronto, ON, Canada &nbsp;A1B2C3<br />
              416-555-1234*/
              this.props.user.companyInfo
            }
          </div>
        </div>
        <h2>Purchase Order Invoice</h2>
          <PurchaseOrderInvoiceTable products={this.props.info.products} payments={this.props.info.payments}/>
          <br></br>
        <div className={styles.totalContainer}>
          <form>
            <div className={styles.valueTable}>
              <div className={styles.row}>
                <div className={styles.label}>Sub Total</div>
                <div className={`${styles.value} ${styles.currency}`}>{this.formatCurrency(this.props.info.subTotal)}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Tax ({this.taxRate}%)</div>
                <div className={`${styles.value} ${styles.currency}`}>{this.formatCurrency(this.props.info.taxTotal)}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Invoice Amount</div>
                <div className={`${styles.value} ${styles.currency}`}>{this.formatCurrency(this.props.info.currentAmount)}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Grand Total</div>
                <div className={`${styles.value} ${styles.currency}`}>{this.formatCurrency(this.props.info.grandTotal)}</div>
              </div>
              <div className={styles.row}>
                <div className={styles.label}>Status</div>
                <div className={`${styles.value} ${styles.currency}`}>{this.props.info.status}</div>
              </div>
            </div>
          </form>
        </div>
        <div className={styles.footer}>
          <div className={styles.closing}>
            <div>Thank-you for your business</div>
          </div>
        </div>
      </div>
    )
  }
};

export default PurchaseOrderInvoice;
